import { call, put, takeLatest } from "redux-saga/effects";
import { vppsAPI } from "../api/api";
import { VppsActionTypes } from "../actions/actionTypes";
import { API } from "../../../api/api";

function* getSubsidiaries(action) {
    try {
        const subsidiaries = yield call(() => vppsAPI.getSubsidiaries());
        yield put({
            type: VppsActionTypes.GET_SUBSIDIARIES_SUCCESS,
            payload: {
                subsidiaries: subsidiaries.data.results
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting subsidiary list.");

        yield put({
            type: VppsActionTypes.GET_SUBSIDIARIES_FAIL,
            message: e.message
        });
    }
}

export function* getSubsidiariesWatcher() {
    yield takeLatest(VppsActionTypes.GET_SUBSIDIARIES, getSubsidiaries);
}
